// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__245t5","buttons":"PendingPaymentAlert_buttons__IbU79"};